<template>
	<div id="parentx" style="margin-top: 50px">
		<div class="col-12">
			<!--			<b-form-input class="form-control mousetrap ui-autocomplete-input" id="search_client"-->
			<!--						  placeholder="" autofocus=""-->
			<!--						  ref="searchClient"-->
			<!--						  @input="filterClientChanged"-->
			<!--						  name="search_client"-->
			<!--						  type="text" autocomplete="off">-->

			<!--			</b-form-input>-->
			<b-input-group size="sm" class="shadowed-group">
				<b-form-input size="sm" id="color"
							  ref="searchClient"
							  v-model="lastName"
							  @input="inputSearchClient"
							  :placeholder="$t('incomes.search.search')"
							  autocomplete="off"
				>
				</b-form-input>
				<b-input-group-addon>
					<b-button @click="searchLast">
						<i class="fa fa-search"></i>
					</b-button>
				</b-input-group-addon>

			</b-input-group>
			<with-keyboard-control :listLength="itemsForSearch.length" style="max-height: 300px"
								   @selected="selectedHandler"
								   :current-index="currentIndex"
								   ref="withKeyboardClient"
			>

				<template slot-scope="{selectedIndex}">
					<!--<div-->
						<!--v-for="(item, index) in itemsForSearch"-->
						<!--class="list-item"-->
						<!--:class="{'selected': index === selectedIndex }"-->
						<!--v-if="itemsForSearch.length >0"-->
						<!--:key="item.id"-->
						<!--@click="clickMouseClient(item)"-->
					<!--&gt;-->
						<!--<b-radio v-bind:value="item" @change="radioChecked" v-model="currentClient"
                                 name="clientRadio"></b-radio>-->
						<!--<strong>{{ index + 1 }}</strong>-->
						<!--<span class="productName mb-0">{{item.firstName}}</span>-->
						<!--<span>{{item.lastName}}</span>-->
						<!--<span>{{item.phone}}</span>-->
						<!--<span>{{item.gender}}</span>-->
						<!--<span>{{item.memberCard}}</span>-->
						<table  v-if="itemsForSearch.length>0" class="table-responsive table-wrapper striped hover" style="background: white;">
							<thead>
							<tr>
								<th class="alignedLeft" style="width: 8%; word-break: break-all;">{{$t('users-l.Id')}}</th>
								<th class="alignedRight" style="width: 10%;">{{$t('client.create.first-name')}}</th>
								<th class="alignedRight" style="width: 10%;">{{$t('client.create.last-name')}}</th>
								<th class="alignedCenter" style="width: 60%">{{$t('client.cart')}}</th>
								<th class="alignedRight" style="width: 10%">{{$t('client.create.mobile')}}</th>
							</tr>
							</thead>
							<tbody>
							<tr v-for="(item, index) in itemsForSearch"
								class="list-item"
								:class="{'selected': index === selectedIndex }"
								v-if="itemsForSearch.length >0"
								:key="item.id"
								@click="selectedHandler(index)">
								<td >{{index + 1 }}</td>
								<td>{{item.firstName}}</td>
								<td>{{item.lastName}}</td>
								<td>{{item.memberCard}}</td>
								<td>{{item.phone}}</td>

								<!--<td>{{value[value.length-1].maxValue}}</td>-->


							</tr>

							</tbody>
						</table>
					<!--</div>-->


				</template>
			</with-keyboard-control>
		</div>
	</div>
</template>

<script>
import {mapActions, mapGetters, mapState} from 'vuex';
import WithKeyboardControl from "./WithKeyboardControl";

export default {
		name: "ClientMemberCard",
		components: {
			WithKeyboardControl
		},
		props: {
			currentIndex: Number,
			defaults: {
				type: Array
			}
		},
		data() {
			return {
				items: [],
				memberCard: '',
				active: true,
				lastName: '',
				clientBarcodeScanned: false,
				search: {
					page: 1,
					limit: 10,
					attributes: [
						{
							field: 'lastName',
							value: '',
							option: 'CONTAINS'
						},

					]
				}
			}

		},
		computed: {
			...mapGetters('clients', [
				'getFromModalMemberCard', 'getCurrentClient'
			]),
			...mapState('clients', [
				'itemsForSearch',
			]),
			...mapState('pos', [
				'currentSaleId'
			]),


		},
		methods: {
			...mapActions('clients', [
				'getMemberCardStore', 'searchLastNameStore', 'setCurrentClient'
			]),
			/*async filterClientChanged(newVal) {
				if (newVal != undefined) {
					await this.searchLastNameStore(newVal);
					if (this.getCurrentClient.firstName) {
						this.$emit("closeMe", {active: false, message: ""});
					} else {
						this.$emit("closeMe", {active: true, message: "Karta raqam topilmadi"});
					}
				}
				if (newVal == "") {
					this.$emit("closeMe", {active: true, message: ""});
				}
			},*/
			inputSearchClient(value) {
				if (!this.clientBarcodeScanned) {
					this.searchLast();
				}
			},
			async searchLast() {
				await this.searchLastNameStore(this.lastName);
				this.$emit('resetCurrentIndex');
			},
			async selectedHandler(selectedIndex) {
				let obj = {};
				await this.setCurrentClient(this.itemsForSearch[selectedIndex]);
				if (this.getFromModalMemberCard.memberCardDiscount) {
					if (this.getFromModalMemberCard.memberCardDiscount >= 0) {
						obj.saleId = this.currentSaleId;
						obj.promotionType = "%";
						obj.discount = this.getFromModalMemberCard.memberCardDiscount;
					}
				} else {
					obj.saleId = this.currentSaleId;
					obj.promotionType = "%";
					obj.discount = 0;
				}
				let payload = {
					obj: obj
				};
				await this.$store.commit('pos/setCustomPromotionGeneral', payload);
				this.clientBarcodeScanned = false;
				this.$emit('saveSuccess');
				// this.$emit("closeMe", {active: false, message: ""});
				await this.$emit('close', false, selectedIndex);
				this.$emit("closeMe", {active: false});
			},
			async clickMouseClient(item) {
				let obj = {};
				if (this.getFromModalMemberCard.memberCardDiscount) {
					if (this.getFromModalMemberCard.memberCardDiscount >= 0) {
						obj.saleId = this.currentSaleId;
						obj.promotionType = "%";
						obj.discount = this.getFromModalMemberCard.memberCardDiscount;
					}
					let payload = {
						obj: obj
					}
					await this.$store.commit('pos/setCustomPromotionGeneral', payload);
				}
				await this.setCurrentClient(item);
				this.$emit("closeMe", {active: false});
			},
			async posBarcodeScannedClient(barcodeNumber) {
				this.clientBarcodeScanned = true;
				if (barcodeNumber.length > 3) {
					if (this.itemsForSearch.length <= 0) {
						await this.searchLast();
					}
					if (this.itemsForSearch.length > 0) {
						await this.selectedHandler(0);
					}
				}
			},
		},

		async mounted() {
			await this.$refs.searchClient.focus();
//			await this.filterClientChanged();
			await this.searchLast("");
		},
		created() {
//			this.$barcodeScanner.init(this.searchLast);
			this.$barcodeScanner.init(this.posBarcodeScannedClient);
		},
		watch: {
			'search.attributes':
				{
					handler() {
						this.searchLast();
					}
				},
			'lastName': {
				handler() {
					if (this.lastName == "") {
//						this.searchLast();
					} else {
//						this.searchLast();
					}

				}
			},
			itemsForSearch: {
				handler() {
					if (this.itemsForSearch.length > 0) {
						this.$refs.withKeyboardClient.addKeyHandler();
					} else {
						this.$refs.withKeyboardClient.removeKeyHandler();
					}
				}
			}
		}
	}
</script>

<style lang="scss">
	#app {
		display: flex;
		justify-content: center;
		align-items: center;
		flex-direction: column;
		height: 100vh;
	}

	.list-item {
		justify-content: space-around;
		padding: 5px;
		border: 1px solid #eee;
		cursor: pointer;
	}

	.list-item:hover,
	.list-item.selected {
		background-color: lightgrey;
	}
</style>
